import { render } from "./DbQueryPropsCmp.vue?vue&type=template&id=bb4763c0"
import script from "./DbQueryPropsCmp.vue?vue&type=script&lang=js"
export * from "./DbQueryPropsCmp.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__